function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { WDHComponent } from '../../../../wdh-foundation/wdh';
import React from 'react';
import ReactDom from 'react-dom';
import UsersList from '../js/partials/users-list';

/**
 * @memberOf module:wdh-plain-text-spot
 */
var WDHRemotecareAdminPanel = /*#__PURE__*/function (_WDHComponent) {
  /**
   * @param {String} className - The unique css selector that triggers the component
   * @constructor
   * @augments WDHComponent
   * @inheritDoc
   */
  function WDHRemotecareAdminPanel() {
    var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'remotecare-admin-panel';
    _classCallCheck(this, WDHRemotecareAdminPanel);
    return _callSuper(this, WDHRemotecareAdminPanel, [className]);
  }
  _inherits(WDHRemotecareAdminPanel, _WDHComponent);
  return _createClass(WDHRemotecareAdminPanel, [{
    key: "init",
    value: function init(component) {
      // Here you add the code to initiate your component. This is run once when the page is ready
      var componentContent = component.querySelector('.remotecare-admin-panel-userlist-table tbody');
      ReactDom.render(/*#__PURE__*/React.createElement(ReactUserListComponent, null), componentContent);
    }
  }, {
    key: "resize",
    value: function resize(component) {
      // Here you add code to handle the page being resized. This is called every time the page is resized.
    }
  }, {
    key: "scroll",
    value: function scroll(component, scrollTop) {
      // Here you add code to handle the page being scrolled. This is called every time the page is scrolled.
    }
  }]);
}(WDHComponent);
var ReactUserListComponent = /*#__PURE__*/function (_React$Component) {
  function ReactUserListComponent() {
    _classCallCheck(this, ReactUserListComponent);
    return _callSuper(this, ReactUserListComponent, arguments);
  }
  _inherits(ReactUserListComponent, _React$Component);
  return _createClass(ReactUserListComponent, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(UsersList, null);
    }
  }]);
}(React.Component);
export default WDHRemotecareAdminPanel;